<script setup>
const { tm } = useI18n();
const policy = tm("privacy_policy");
</script>

<template>
    <div
        class="px-[4.07vw] pb-[12.14vh] pt-[calc(14vh+var(--header-height))] xs:px-[16px] sm:px-[5.21vw] sm:pb-[15.625vw] sm:pt-[calc(14.58vw+var(--header-height))] lg:mx-auto lg:w-[62.7vw] lg:max-w-[948px] lg:px-0 lg:pb-[13.23vw] lg:pt-[calc(7.41vw+var(--header-height))] 3xl:pb-[254px] 3xl:pt-[calc(142.2px+var(--header-height))]"
    >
        <div
            class="flex flex-col gap-[2.03vw] xs:gap-[8px] sm:gap-[1.04vw] lg:gap-[0.53vw] 3xl:gap-[10.2px]"
        >
            <p class="slt-h4 text-primary-orange">
                {{ $rt(policy.name) }}
            </p>
            <div
                class="flex flex-col gap-[4.07vw] xs:gap-[16px] sm:flex-row sm:items-end sm:justify-between"
            >
                <h1 class="slt-h1 text-base-black">
                    {{ $rt(policy.title) }}
                </h1>
                <p
                    class="flex items-baseline gap-[3.05vw] xs:gap-[12px] sm:gap-[1.56vw] lg:gap-[0.79vw] 3xl:gap-[15.2px]"
                >
                    <span class="slt-h6 text-base-black-20">{{
                        $rt(policy.update)
                    }}</span>
                    <span class="slt-h5 text-base-black-60">{{
                        $rt(policy.date)
                    }}</span>
                </p>
            </div>
        </div>
        <div
            class="slt-privacy-policy-container mt-[12.21vw] flex flex-col gap-[10.18vw] text-justify xs:mt-[48px] xs:gap-[40px] sm:mt-[6.25vw] sm:gap-[5.21vw] lg:mt-[4.76vw] lg:gap-[4.23vw] 3xl:mt-[91.4px] 3xl:gap-[81.3px]"
        >
            <p class="slt-body-1 bold !leading-[1.7] text-base-black-80">
                {{ $rt(policy.summary) }}
            </p>
            <PrivacyPolicyList
                :items="policy.sections"
                class="gap-[10.18vw] xs:gap-[40px] sm:gap-[5.21vw] lg:gap-[4.23vw] 3xl:gap-[81.3px]"
            />
        </div>
    </div>
</template>
